import {
    Instance,
    Promize,
    Table,
    Viewer,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { AssetService } from '@services/assetService';
import { LanguageService } from '@services/languageService';
import { ObservationService } from '@services/observationService';
import { OrganizationService } from '@services/organizationService';
import { initTable } from '@utils/collectionSetup';
import { DashboardController } from './dashboardController';

export class ObservationsIndexByOrganizationController extends DashboardController {
    static readonly inject = [
        'instances',
        'observationService',
        'organizationService',
        'assetService',
        'languageService',
    ] as const;

    viewer: Viewer;
    organizationId!: string;
    observationsTable!: Table;

    constructor(
        instances: Instance,
        private observationService: ObservationService,
        private organizationService: OrganizationService,
        private assetService: AssetService,
        private languageService: LanguageService,
    ) {
        super(instances);

        this.viewer = instances.viewer;
    }

    protected override _initLayout(): void {
        this.organizationId = this.state.getParam('organizationId');

        this._initToolbarButtons();
        this._initFilterForm();

        this._drawContent();
    }

    protected override _drawContent(): Promize | boolean {
        this._initObservationCollection();
        return true;
    }

    private _initToolbarButtons(): void {
        this.helper.iconButton('.btn-organizations-show', this.dom, () => {
            this.state.goBack('organizations.show', {});
        });
    }

    private _initObservationCollection(): void {
        this.observationsTable = initTable(
            this.observationsTable,
            this.dom,
            '.observations-table',
            this.observationService,
            {
                entityKey: 'observations',
                fetchData: (params) =>
                    this.observationService.getAllByOrganization(
                        this.organizationId,
                        params,
                    ),
                extraParams: (params) => params.set('query', this.query),
            },
            [
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (observation) => {
                        this.observationService
                            .editDialog(observation)
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ],
        )!;
    }
}

export const observationsIndexByOrganizationController = app.controller(
    'observationsIndexByOrganizationController',
    ObservationsIndexByOrganizationController,
);
